import { AppliedFilters } from "@next-platform/client-common-spicy-ui";
import React from "react";

import AppliedFilterChipCharacter from "./AppliedFilterChipCharacter";
import type { AppliedFilterChipData } from "./types";

type AppliedFiltersBarViewProps = {
  resultCountText: string;
  chips: AppliedFilterChipData[];
  onRemoveChip: (chip: AppliedFilterChipData) => void;
  onClearAll: () => void;
  getRemoveAriaLabel: (label: string) => string;
  clearAllLabel: string;
  hasAppliedFilters: boolean;
};

const AppliedFiltersBarView = ({
  resultCountText,
  chips,
  onRemoveChip,
  onClearAll,
  getRemoveAriaLabel,
  clearAllLabel,
  hasAppliedFilters,
}: AppliedFiltersBarViewProps) => {
  const chipElements = chips.map((chip) => (
    <AppliedFilterChipCharacter key={chip.key} chip={chip} getRemoveAriaLabel={getRemoveAriaLabel} onRemoveChip={onRemoveChip} />
  ));
  const hasChips = chips.length > 0;

  return (
    <AppliedFilters data-testid="AppliedFiltersBarView">
      <AppliedFilters.ResultCount data-testid="AppliedFiltersBarView-ResultCount">{resultCountText}</AppliedFilters.ResultCount>
      {hasChips ? <AppliedFilters.Divider data-testid="AppliedFiltersBarView-Divider" /> : null}
      {chipElements}
      {hasAppliedFilters ? (
        <AppliedFilters.ClearAll data-testid="AppliedFiltersBarView-ClearAll" onClick={onClearAll}>
          {clearAllLabel}
        </AppliedFilters.ClearAll>
      ) : null}
    </AppliedFilters>
  );
};

export default React.memo(AppliedFiltersBarView);
